module.exports = __webpack_public_path__ + "static/media/llamamos.8f17b263.png";